import { defineStore } from 'pinia'
import { reactive, readonly, computed } from 'vue'

interface ILocationRedirectStoreState {
	redirectLang: string | null
	redirectUrlSlice: string | null
}

interface ILocationRedirectStore {
	readonly state: ILocationRedirectStoreState
	setRedirectUrlSlice: (locations: string) => void
	setRedirectLang: (redirect: string) => void
	getRedirectUrlSlice: ComputedRef<string | null>
	getRedirectLang: ComputedRef<string | null>
}

export const useLocationRedirectStore = defineStore('locationRedirectStore', (): ILocationRedirectStore => {
	const _state = reactive<ILocationRedirectStoreState>({
		redirectLang: null,
		redirectUrlSlice: null,
	})

	const setRedirectUrlSlice = (slice: string): void => {
		_state.redirectUrlSlice = slice
	}

	const setRedirectLang = (redirect: string): void => {
		_state.redirectLang = redirect
	}

	const getRedirectUrlSlice = computed(() => _state.redirectUrlSlice)

	const getRedirectLang = computed(() => _state.redirectLang)

	return {
		state: readonly(_state),
		setRedirectUrlSlice,
		setRedirectLang,
		getRedirectUrlSlice,
		getRedirectLang,
	}
})
